import React, { useContext, useEffect, useState } from 'react'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'
import editPen from '../../../../assets/certificates/Tables/pencil.svg'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from '../../../../components/styles/table-style'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { CertificateOutletType } from '..'
import axios from 'axios'
import ModalContext from '../../../../contexts/ModalContext'
import CertificatesContext from '../../../../contexts/CertificatesContext'

interface CertificateTypeForTable {
  id: number,
  param: string
  supplier: string
  customer: string
  heatNumber: string
  type: string
  date: string
}

const CertificatesTable: React.FC = () => {
  const [ certificates, setCertificates ] = useState<CertificateTypeForTable[]>([])
  const { setTabIndex } = useOutletContext<CertificateOutletType>()
  const navigate = useNavigate()
  
  useEffect(() => {
    setTabIndex(0)
  }, [])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/certificate`)
      .then(response => {
        if(response.data) setCertificates(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  }, [])
  
  const columns = ['Parâmetro', 'Fornecedor', 'Cliente', 'Tipo do certificado', 'Nº da corrida', 'Data de criação']

  return (
    <GlobalTable>
      <thead>
        <HeaderLine>
          {columns.map((item, colIndex) => (
            <Th key={colIndex}>{item}</Th>
          ))}
          <Th></Th>
        </HeaderLine>
      </thead>
      <tbody>
        {certificates.map((certificate, index) => 
          <Tr key={index}>
            <Td>{certificate.param}</Td>
            <Td>{certificate.supplier}</Td>
            <Td>{certificate.customer}</Td>
            <Td>{certificate.type}</Td>
            <Td>{certificate.heatNumber}</Td>
            <Td>{certificate.date}</Td>
            <TdButtons>
              <img src={lookup} alt='looup-icon' onClick={() => navigate(`view/?id=${certificate.id}`)} />
              <img src={editPen} alt='edit-icon' onClick={() => navigate(`edit/?id=${certificate.id}`)} />
            </TdButtons>
            
          </Tr>
        )}
      </tbody>
    </GlobalTable>
  )
}
export default CertificatesTable